import { Radio as AntdRadio } from "antd";
import React from "react";

export type MyRadioProps = React.ComponentProps<typeof AntdRadio>;

export interface RadioStaticMethods {
  Group: typeof AntdRadio.Group;
  Button: typeof AntdRadio.Button;
}

const Radio = React.forwardRef<any, MyRadioProps>((props, ref) => {
  return <AntdRadio ref={ref} {...props} />;
}) as React.ForwardRefExoticComponent<MyRadioProps & React.RefAttributes<any>> &
  RadioStaticMethods;

Radio.Group = AntdRadio.Group;
Radio.Button = AntdRadio.Button;

export default Radio;
